import React from 'react';
import './About.css';
import { useLanguage } from '../context/LanguageContext';
import Icon from '../components/Icon';

const About = () => {
  const { t } = useLanguage();

  const detailedHistorySections = t('about.historySections', { returnObjects: true }) || [];
  const milestones = t('about.milestones', { returnObjects: true }) || [];

  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="hero-pill">{t('nav.about')}</span>
          <h1>{t('about.heritageTitle')}</h1>
          <div className="header-divider">
            <span className="dot"></span>
            <span className="line"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>

      <div className="container">
        <section className="vision-intro-section">
          <div className="vision-card">
            <h2>{t('about.divineOrigin')}</h2>
            <p>{t('about.divineOriginText1')}</p>
            <div className="decorative-line"></div>
            <p>{t('about.divineOriginText2')}</p>
          </div>
        </section>

        <section className="history-grid-section">
          <div className="section-header">
            <h2 className="section-title">{t('about.journeyTitle')}</h2>
            <div className="title-underline"></div>
          </div>
          <div className="history-grid">
            {detailedHistorySections.map((section, idx) => (
              <div className="history-card" key={idx}>
                <div className="history-icon"><Icon name={section.icon} /></div>
                <h3>{section.title}</h3>
                {section.paragraphs.map((p, pIdx) => (
                  <p key={pIdx}>{p}</p>
                ))}
              </div>
            ))}
          </div>
        </section>

        <section className="milestones-timeline-section">
          <div className="section-header">
            <h2 className="section-title">{t('about.milestonesTitle')}</h2>
            <div className="title-underline"></div>
          </div>
          <div className="milestones-row">
            {milestones.map((m, idx) => (
              <div className="milestone-box" key={idx}>
                <div className="milestone-year">{m.year}</div>
                <div className="milestone-dot"></div>
                <p>{m.detail}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="cultural-significance-section">
          <div className="glass-content-card">
            <h2>{t('about.culturalImportance')}</h2>
            <div className="content-grid">
              <div className="text-side">
                <p>{t('about.culturalText1')}</p>
                <p>{t('about.culturalText2')}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;

